import { Component, Inject ,OnInit } from '@angular/core';
import * as _ from "lodash";
import { projectActions } from '@src/store/reducers/projectReducer';
import { Store } from '@src/store';
import { FakeWaffle } from './fakewaffle-ang7';
import { TranformtionImpactServerClientFilterObjectService } from '@src/services';
import $ from 'jquery';
import { consts } from '@src/constants/consts';

@Component({
    selector: 'impact-analysis',
    template: require('./impact-analysis.html'),
    styles: [require('./_impact-analysis.scss')]
})
export class ImpactAnalysisComponent implements OnInit {
    public processData: any;
    public errorOnReport:boolean = false;
    public isRollbackExecution: boolean
    public report_subscripe:any
    public pageLoaded:boolean = false;
    public headerClasses:any = { policy: [], changes: [], content: [], precheck: [] };
    public headerCount:any = { policy: 0, changes: 0, content: 0, precheck: 0 };
    // , @Inject('statuses') private $statuses: any

    constructor(@Inject('$stateParams') private $stateParams: any , private store : Store 
    ,@Inject('$filter') private $filter: any ,
    private tranformtionImpactServerClientFilterObjectService : TranformtionImpactServerClientFilterObjectService,
    @Inject('$state') private $state: any) {

    }

    ngOnInit(): void {
        
        this.store.dispatch({
            type: projectActions.GET_PROJECT_ENUMS
        });
        this.store.dispatch({
            type: projectActions.GET_IMPACT_ANALYSIS_INIT,
            payload: {
                projectId: this.$stateParams.projectId,
                jobId: this.$stateParams.jobId,
                jobType: this.$stateParams.jobType,
                jobEnv: this.$stateParams.jobEnv,
                reportId: this.$stateParams.reportId,
            }
        }).then((resp) =>{
            if (resp.status != 200) {
                this.errorOnReport = true;
            }
        });
        this.loadPageData();
    }

    loadPageData():void {
        console.log('loadPageData');
        const _this = this;
        if (this.report_subscripe) {
            this.report_subscripe();
        }
        this.report_subscripe = this.store.subscribe(() => {
            if (this.store.getState().project.impact_analysis && this.store.getState().enums) {
                console.log('inif');
                this.processData = this.tranformtionImpactServerClientFilterObjectService.getNewjsonData(this.store.getState().project.impact_analysis, this.store.getState().enums,this.$stateParams.jobEnv,this.$filter('changeEnumJobNameToName'));;

                //hot fix till server side ajax will be good to go
                this.processData.reportName = consts.reportType[this.$state.params.jobType ? this.$state.params.jobType:"default"] + ' Report';
                this.processData.entityJobType =  _this.$stateParams.jobType;
                this.pageLoaded = true;
                this.report_subscripe();
                this.calculateHeaders();
            }
            console.log('inelse');
        });
    }

    calculateHeaders() {
        this.headerClasses = { policy: [], changes: [], content: [], precheck: [] };
        this.headerCount = { policy: 0, changes: 0, content: 0, precheck: 0 };
        if (this.processData) {
            if (this.processData.policyResults) {
                this.headerCount.policy = this.processData.policyResults.length;
                if (this.headerCount.policy > 0) {
                    this.headerClasses.policy = this.processData.policyResults.find(x => x.action === 'Block') ? ['red'] : ['yellow'];
                }
            }
            //check for objects in structure analysis
            if (!this.processData.preRunTestResultList || this.processData.preRunTestResultList.length === 0 ) {
                const isValidateOrUpgrade = this.processData.jobType === 'ENV_VALIDATE' || this.processData.jobType === 'ENV_DEPLOYMENT';
                if (this.processData.changes) {
                    this.headerCount.changes = this.processData.changes.length;
                    this.headerClasses.changes = this.headerCount.changes > 0 && isValidateOrUpgrade ? ['red'] : [];
                }
                if (this.processData.contentChanges) {
                    this.headerCount.content = this.processData.contentChanges.length;
                    this.headerClasses.content = this.headerCount.content > 0 && isValidateOrUpgrade ? ['red'] : [];
                }
            } else if (this.processData.preRunTestResultList) {
                this.headerCount.precheck = this.processData.preRunTestResultList.length;
                this.headerClasses.precheck = this.headerCount.precheck > 0 ? ['red'] : [];
            }
        }

        let activeTab = '';
        const headers = Object.keys(this.headerCount);
        for (let i = 0; i < headers.length; i++) {
            const tabName = headers[i];
            if (this.headerCount[tabName] > 0) {
                activeTab = tabName;
                break;
            }
        }
        if (!activeTab) {
            activeTab = 'scopes';
        }
        
        setTimeout(() => {
            const fakeWaffle = new FakeWaffle();
            fakeWaffle.responsiveTabs();
            setTimeout(() => {
                const prefix = fakeWaffle.currentPosition === 'tabs' ? '' : 'collapse-';
                $('.tab-group a').collapse('hide');
                $(`a[href="#${prefix}analysis-${activeTab}"]`).click()
            }, 0);
        }, 0);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis.component.ts